import TitleSection from "../components/TitleSection";
import DataPartners from "../components/DataPartners";
import Resources from "../components/Resources";
import data from "../../../datasets/usecases/applicationprefill";
import Recipes from "../components/Recipes";
// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";

export const ApplicationPreFill = () => {
  return (
    <div className="application_prefill_landing">
      <TitleSection data={data} />
      <Recipes data={data} />
      <DataPartners dataPartners={data.dataPartners} />
      <Resources {...data} />
      {/* <PricingGetStarted /> */}
    </div>
  );
};
